import { DefaultMessages, ProgramThemeMessages, SegmentSpecificMessages } from '@sheerid/jslib';
import { RecursivePartial } from '../types/types';


type LibraryMessages = DefaultMessages & SegmentSpecificMessages & ProgramThemeMessages;

type ThisProjectMessages = {
    step:{
        personalInfo:{
            requiredField: string;
        };
        docUpload:{
            getHelpLink: string;
        };
    };
};

export const messagesPT: RecursivePartial<LibraryMessages & ThisProjectMessages> = {
    step: {
        personalInfo: {
            title: 'Aproveite esta oferta exclusiva para estudantes',
            subtitle: 'Confirme que você estuda em uma instituição que seja elegível e que conceda diploma.',
            howDoesVerifyingWorkDetails: 'Para se qualificar para esta oferta, você deve estar matriculado em uma instituição de educação credenciada e que conceda um diploma e/ou certificado.<br><br>\n A {companyName} usa a SheerID, uma parceira de confiança, para verificar se sua elegibilidade e se é atualmente um estudante. A SheerID\n só coleta informações que auxiliem na verificação da sua qualificação.\n Informações ou documentos adicionais podem ser solicitados.',
            requiredField: '* indica um campo obrigatório',
        },
        success: {
            title: 'Verificação concluída.',
            subtitle: 'Segue o seu código pessoal. Esse codigo é exclusivo e intransferível para uso único',
            emailNotification: 'Enviamos uma cópia do código por e-mail para que você possa utilizá-lo a qualquer momento. Procure um e-mail enviado por confirm@sheerid.com.',
            redirectButtonText: 'Resgatar Agora',
            verificationOnly: 'A SheerID faz apenas a verificação de seus dados. Agora que eles foram aprovados, todas as perguntas sobre os termos da promoção e/ou uso de códigos devem ser enviados para o serviço de atendimento ao <a href=https://www.linkedin.com/help/linkedin/answer/a737731 class="sid-link" target="_blank"> cliente do LinkedIn.</a>',
        },
        sso: {
            title: 'Confirme seus dados usando as suas credenciais associadas à instituição de ensino',
            subtitle: 'Entre no site da sua instituição de ensino. Ele será aberto em uma nova guia.',
            login: 'Acessar minha instituição de ensino',
            subtitle2: 'Não consegue acessar seu e-mail?',
        },
        emailLoop: {
            title: 'Verifique o seu e-mail',
            subtitleWithEmail: 'Enviamos um e-mail para {email} com um link exclusivo para concluir o seu processo de verificação.',
            subtitle2: 'Verifique o e-mail que enviamos (verify@sheerid.com) para acessar todos os detalhes.',
            skipEmail: 'Não recebeu o e-mail? Clique ',
            skipEmail2: ' para que o reenviemos.',
        },
        docUpload: {
            title: 'Necessitamos de um documento e da sua grade curricular ',
            subtitle: 'Seus documentos serão revisados em alguns minutos pela equipe da SheerID, um parceiro confiável.',
            getHelpLink: 'Preciso de ajuda',
            acceptableUploads: {
                student: {
                    classSchedule: 'Cronograma de aulas e/ou grade curricular',
                },
            },
            uploadInstructions: 'Faça upload do seu documento emitido pela instituição de ensino que mostre',
            uploadInfo: {
                student: {
                    school: 'O nome da sua instituição de ensino',
                    enrollmentDate: 'Uma data que comprove sua matrícula no semestre atual (ou nos últimos 3 meses)',
                },
            },
            acceptableUploadExamples: 'Entre os exemplos aceitáveis para o último item estão:',
            fileInstructions: 'Arraste e solte seus arquivos aqui ou <span class="sid-dropzone-wrap__link">clique aqui</span>',

        },
        pending: {
            subtitleCountdown: 'Aguarde enquanto carregamos e verficamos os seus documentos.',
            titleReview: 'Em revisão',
            subtitleAlt: 'O tempo necessario de verificação são de poucos minutos, e em caso de alto volume, pode levar até  2 horas',
            turnaroundTime: 'Normalmente, o tempo de resposta para seu idioma é de apenas alguns minutos. Em situações onde o volume de verificações é elevado, o processo pode demorar até 24 horas.',
            subtitle2: 'Aguarde aqui ou aguarde nossa notificação por e-mail.',
        },
        error: {
            errorId: {
                noRemainingRewardCodes: {
                    title: 'Oferta encerrada. Esta oferta não está mais disponível.',
                },
            },
        },
    },
    howDoesVerifyingWork: 'Como a verificação é realizada?',
    getHelp: 'Preciso de ajuda',
    tryAgain: 'Tente novamente',
    errorId: {
        underagePerson: 'Pessoas menores de 18 anos não se qualificam para esta oferta.',
        docReviewLimitExceeded: 'Limite de revisão de documentos excedido',
        verificationLimitExceeded: 'Ficamos felizes com seu entusiasmo, mas parece que você já resgatou ou tentou resgatar esta oferta.',
        fraudRulesReject: 'Não foi possível verificar as informações enviadas. Verifique se suas informações estão corretas e utilize apenas seu próprio dispositivo móvel ou computador. <br><br>Ainda com problemas? <a href=\"{feedbackUrl}&pid={programId}&locale={locale}\">Entre em contato com a equipe de suporte da SheerID</a> para confirmar a sua identidade.',
        noRemainingRewardCodes: ' ',
    },
    emailExplanation: 'De preferência um e-mail associado à instituição.',
    footerText: 'Reconheço que as informações pessoais acima serão coletadas de acordo com a política de privacidade da empresa da qual obterei uma oferta especial e entendo que elas serão compartilhadas com a SheerID, um processador/provedor de serviços terceirizado, para confirmar minha elegibilidade para essa oferta. Também reconheço que sou elegível para esta oferta. <aboutSheerID> Mais informações sobre a SheerlD.</aboutSheerID> ',
};
